import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const Sun: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <>
      <path d="M23.35 3v4h1.3V3h-1.3Zm-11.83 9.439L7.984 8.903l.92-.919 3.535 3.536-.92.919Z" />
      <path
        fillRule="evenodd"
        d="M24 38c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Zm0-1.3c7.014 0 12.7-5.686 12.7-12.7 0-7.014-5.686-12.7-12.7-12.7-7.014 0-12.7 5.686-12.7 12.7 0 7.014 5.686 12.7 12.7 12.7Z"
        clipRule="evenodd"
      />
      <path d="M39.097 40.016 35.56 36.48l.92-.919 3.535 3.536-.92.919ZM23.35 45v-4h1.3v4h-1.3ZM3 23.35h4v1.3H3v-1.3Zm42 0h-4v1.3h4v-1.3ZM7.984 39.097l3.536-3.536.919.92-3.536 3.535-.919-.92ZM35.561 11.52l3.536-3.536.919.92-3.536 3.535-.919-.92Z" />
    </>
  );

  const normalHover = (
    <>
      <path d="M28.807 3.547 27.772 7.41l1.256.336 1.035-3.864-1.256-.336Zm-13.87 6.055-2.5-4.33 1.126-.65 2.5 4.33-1.126.65Z" />
      <path
        fillRule="evenodd"
        d="M20.377 37.523c7.468 2 15.145-2.431 17.146-9.9 2.001-7.469-2.431-15.145-9.9-17.146-7.468-2.002-15.145 2.43-17.146 9.9-2.001 7.468 2.431 15.144 9.9 17.146Zm.336-1.256c6.775 1.815 13.739-2.205 15.554-8.98 1.816-6.775-2.205-13.74-8.98-15.555-6.775-1.815-13.739 2.206-15.554 8.98-1.816 6.776 2.205 13.74 8.98 15.555Z"
        clipRule="evenodd"
      />
      <path d="m34.437 43.377-2.5-4.33 1.126-.65 2.5 4.33-1.126.65Zm-16.5.739 1.035-3.864 1.256.337-1.035 3.863-1.256-.336ZM3.884 17.936l3.864 1.036-.337 1.255-3.864-1.035.337-1.256Zm40.569 10.871-3.864-1.035-.337 1.255 3.864 1.036.337-1.256Zm-39.831 5.63 4.33-2.5.65 1.125-4.33 2.5-.65-1.125Zm33.776-19.5 4.33-2.5.65 1.126-4.33 2.5-.65-1.126Z" />
    </>
  );

  return getIcon({ size, isHovered, normal, normalHover });
};

export default Sun;
